'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import GradeTypeConstants from '../../constants/GradeTypeConstants';
/**
 * Simply wraps the appropriate classes around its children.
 */

var ResultSection = /*#__PURE__*/function (_React$Component) {
  _inherits(ResultSection, _React$Component);

  function ResultSection() {
    _classCallCheck(this, ResultSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResultSection).apply(this, arguments));
  }

  _createClass(ResultSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          gradeType = _this$props.gradeType,
          children = _this$props.children;
      var classes = classNames('result-section', gradeType === GradeTypeConstants.GREAT && 'result-section-great', gradeType === GradeTypeConstants.GOOD && 'result-section-good', gradeType === GradeTypeConstants.OK && 'result-section-ok', gradeType === GradeTypeConstants.BAD && 'result-section-bad');
      return /*#__PURE__*/_jsx("div", {
        className: classes,
        "data-reagan-selector": "result-section",
        children: children
      });
    }
  }]);

  return ResultSection;
}(React.Component);

ResultSection.propTypes = {
  gradeType: PropTypes.string,
  children: PropTypes.node
};
export { ResultSection as default };